import classNames from 'classnames'
import React from 'react'

interface ModalCloseButtonProps {
  className?: string
  title?: string
  onClick?: () => void
}

const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({className, ...rest}) => (
  <button
    className={classNames('close-button', className)}
    type="button"
    {...rest} // className, onClick, title, etc.
  >
    <span className="u-sr-only">Close modal</span>
    <svg className="close-button-svg">
      <use xlinkHref="#icon-close" />
    </svg>
  </button>
)

export default ModalCloseButton
